import { insertIf } from '../../../utils';
import { createTag } from './CacheTagTypes';
/**
 * Creates all possible stream cache tag combinations.
 * @private
 * @category Cache Tags
 */
export const createStreamsTags = ({ chainId, address1, address2, address3 }) => [
    streamTag(chainId),
    ...insertIf(address1, streamTag(chainId, address1)),
    ...insertIf(address2, streamTag(chainId, address2)),
    ...insertIf(address3, streamTag(chainId, address3)),
    ...insertIf(address1 && address2, streamTag(chainId, address1, address2)),
    ...insertIf(address1 && address3, streamTag(chainId, address1, address3)),
    ...insertIf(address1 && address2 && address3, streamTag(chainId, address1, address2, address3)),
];
/**
 * @private
 * @category Cache Tags
 */
export const getMostSpecificStreamTag = (arg) => {
    return createStreamsTags(arg).reverse()[0];
};
const streamTag = (chainId, ...keys) => createTag('Stream', chainId, ...keys);
//# sourceMappingURL=streamTags.js.map